/**
 * @module components/Form/CoordinatesMap
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * User feedback map with coordinate display and draggable marker
 */

import { useRef } from 'react';

import { LatLngExpression } from 'leaflet';

import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';

import 'proj4leaflet';

import { useLanguageState } from '../../contexts/language-state-provider';


type PropsView = {
  center: LatLngExpression,
  zoom: number,
}

type Props = {
  values: [ number, number ],
  onCoordinates: FormOnCoordinates,
  zoom?: number,
}


const ChangeView = ({ center, zoom }: PropsView) => {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}

/**
 * React component
 * ===============
 */
const CoordinatesMap = ({
  values,
  onCoordinates,
  zoom = 18,
}: Props) => {
  const refmarker = useRef(null);
  const [ lang ] = useLanguageState();

  const origin = [-3.46558E7, 3.931E7]
  const resolutions = [
    38364.660062653464,
    22489.62831258996,
    13229.193125052918,
    7937.5158750317505,
    4630.2175937685215,
    2645.8386250105837,
    1587.5031750063501,
    926.0435187537042,
    529.1677250021168,
    317.50063500127004,
    185.20870375074085,
    111.12522225044451,
    66.1459656252646,
    38.36466006265346,
    22.48962831258996,
    13.229193125052918,
    7.9375158750317505,
    4.6302175937685215,
  ];
  // @ts-ignore: ignore projection error
  const crs = new window.L.Proj.CRS(
    'EPSG:3978',
    '+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
    { origin, resolutions },
  );

  return (
    <MapContainer center={values} zoom={zoom} crs={crs} maxZoom={resolutions.length-1}>
      <ChangeView center={values} zoom={zoom} /> 
      <TileLayer
        attribution={lang.leaflet.attribution}
        url={lang.leaflet.url}
      />
      <Marker
        draggable
        eventHandlers={{
          dragend: (e) => {
            onCoordinates(e.target._latlng.lat, e.target._latlng.lng);
          }
        }}
        position={values}
        ref={refmarker}>
      </Marker>
    </MapContainer>
  );
};


export default CoordinatesMap;